<template>
  <div class="v-select-component" :class="{ fullWidth, maxContent }">
    <div class="v-select-label">
      <div class="v-select-label-text-wrapper">
        <p class="v-select-label-text">{{ label }}</p>
        <transition name="fade">
          <div class="explanation-wrapper" v-if="explanation">
            <p class="explanation-text">{{ explanation }}</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="v-select-wrapper" :class="{white}">
      <select class="v-select" :disabled="disabled" @input="$emit('input', $event.target.value)">
        <option v-for="(option, i) in options" :key="i" :value="option.value" :selected="option.selected">{{ option.title }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrmSelect',
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => []
    },
    explanation: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
    },
    white: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    maxContent: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>
.v-select-component {
  width: 100%;
  display: flex;
  justify-content: space-between;
  &.fullWidth {
    .v-select-wrapper,
    .v-select {
      width: 100%;
    }
  }
  &.maxContent {
    width: max-content;
    margin: 0 auto;
    .v-select-wrapper,
    .v-select {
      width: max-content;
    }
  }
}
.v-select-label-text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px 0;
}
.v-select-label-text {
  font-size: 14px;
}
.explanation-wrapper {}
.explanation-text {
  font-size: 13px;
  color: #999;
  line-height: 1.6;
}
.v-select-wrapper {
  height: max-content;
  position: relative;
  &::before {
    content: '';
    width: 8px;
    height: 100%;
    background: url('~@/assets/images/arrowLineThickDown_blue.svg') no-repeat center / 100% auto;
    position: absolute;
    right: 10px;
    pointer-events: none;
    z-index: 1;
  }
  &.white {
    &::before {
      background: url('~@/assets/images/arrowLineThickDown.svg') no-repeat center / 100% auto;
    }
    .v-select {
      background-color: #eee;
      color: #333;
    }
  }
}
.v-select {
  border: none;
  border-radius: 20px;
  padding: 0 24px 0 10px;
  background-color: #333;
  font-size: 12px;
  color: #fff;
  line-height: 24px;
  appearance: none;
}
</style>
